import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { VehicleEligibleForConformityDto, VehicleEligibleForConformityQueryParams } from 'dtos/toDoLists/conformity'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/conformity/vehicles-eligible-for-conformity`

export const getToDoList = (queryParams: VehicleEligibleForConformityQueryParams, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<VehicleEligibleForConformityDto[]>>(baseUrl() + URIQuery(queryParams), { cancelToken }).then(res => res.data)
